var $54b47fc030b7b21e$exports = {};
var $54b47fc030b7b21e$var$cursor = document.querySelector(".cursor");
var $54b47fc030b7b21e$var$onMouseMove = function() {
    $54b47fc030b7b21e$var$cursor.style.top = event.y + "px";
    $54b47fc030b7b21e$var$cursor.style.left = event.x + "px";
};
document.addEventListener("mousemove", $54b47fc030b7b21e$var$onMouseMove);


//# sourceMappingURL=index.f1e8ca53.js.map
